<template>
  <div class="container-fluid p-0 max-height">
    <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">{{title}}</p>
     </div>
     <form class="w-100 form-general ">
         <createNewPart1 v-if="!part1completed" ></createNewPart1>
         <createNewPart2 v-if="part1completed"  ></createNewPart2>
     </form>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import createNewPart1 from '@/components/containerViews/reservation/createNewPart1.vue'
import createNewPart2 from '@/components/containerViews/reservation/createNewPart2.vue'

export default {
  name: 'NewExpedient',
  components: {
    createNewPart1,
    createNewPart2
  },
   computed: { 
    ...mapGetters("container",{
      reservation_data: 'reservation_data',
    })  
  },
  data() {
    return {
        part1completed: false,
        title: 'Reserva 1/2'
    }
  },
  mounted () {
    this.$store.commit('set_view_name', ['Nueva reserva'])
  },
}
</script>

<style lang= "scss"  scoped>

.max-height {
  overflow-y: auto;
  height: calc(100% - 100px);
}

</style>
